<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>入库</h3>
                </el-col>
                <el-col :span="2">
                    <el-button type="info" @click="handleBack">返回</el-button>
                </el-col>
            </el-row>

            <el-table :data="items">
                <el-table-column prop="id" label="ID">
                </el-table-column>
                <el-table-column prop="name" label="商品名称">
                </el-table-column>
                <el-table-column prop="productCount" label="数量">
                </el-table-column>
                <el-table-column inline-template :context="_self" label="操作">
                    <el-button @click="handleChoose($index, row)" type="text" size="small">入库</el-button>

                </el-table-column>
            </el-table>
            <el-form :model="form" style="margin-top: 30px;">
                <el-form-item v-if="!row.isAlipayMini" label="退款押金数值(单位：分)" label-width="200px">
                    <el-input v-model="backCount"></el-input>
                </el-form-item>
                <el-form-item v-else label="资损扣款(单位：分)" label-width="200px">
                    <el-input v-model="withholdCount"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" :disabled="isFinish" @click="back">确 定</el-button>
            </div>

            <el-form>
                <el-form-item label="用户昵称：" label-width="180px">
                    <span>{{userInfo.nickName}}</span>
                </el-form-item>
                <el-form-item label="手机号：" label-width="180px">
                    <span>{{userInfo.username}}</span>
                </el-form-item>
                <el-form-item label="租赁时间：" label-width="180px" v-if="row.dispalyExtra && row.dispalyExtra.tenancy.length">
                    <el-tag type="gray">{{fromatDate(row.dispalyExtra.tenancy[0].begin)}}</el-tag>
                    <span class="line"></span>
                    <el-tag type="danger">{{rentDay}}天</el-tag>
                    <span class="line"></span>
                    <el-tag type="gray" v-if="row && row.dispalyExtra && row.dispalyExtra.tenancy">{{fromatDate(row.dispalyExtra.tenancy[0].end)}}</el-tag>
                </el-form-item>
                <el-form-item label="租金(单位：元)：" label-width="180px" v-if="row.dispalyExtra">
                    <span>{{row.dispalyExtra.paidData.rental}}</span>
                </el-form-item>
                <el-form-item label="优惠券抵扣(单位：元)：" label-width="180px" v-if="row.dispalyExtra">
                    <span>{{row.dispalyExtra.paidData.discount}}</span>
                </el-form-item>
                <el-form-item label="押金(单位：元)：" label-width="180px" v-if="row.dispalyExtra">
                    <span>{{row.dispalyExtra.paidData.deposit}}</span>
                </el-form-item>
                <el-form-item label="减免押金(单位：元)：" label-width="180px" v-if="row.dispalyExtra">
                    <span>{{row.dispalyExtra.paidData.depositDiscount}}</span>
                </el-form-item>
                <el-form-item label="费用统计(单位：元)：" label-width="180px" v-if="row.dispalyExtra">
                    <span>{{row.dispalyExtra.paymount}}</span>
                </el-form-item>
            </el-form>

        </div>

        <el-dialog title="设备信息" :visible.sync="dialogFormVisible">
            <el-form :model="form">
                <div v-for="i in productVal" :key="i.productId" class="border">
                    <el-form-item label="设备ID" label-width="100px">
                        <span>{{i.deviceId}}</span>
                    </el-form-item>
                    <el-form-item :label="index" label-width="100px" v-for="(item,index) in i.otherProperty" :key="index">
                        <el-input v-model="i.otherProperty[index]"></el-input>
                    </el-form-item>
                </div>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="sureNow">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import {
        getOrderId,
        getExpress,
        getUsersDetail,
        getExpressD,
        getStoragesId,
        deleteOrder,
        putExpress,
        cancelOrder,
        backOrder,
        getProducts,
        sendExpress,
        patchProductsIds,
        finishOrder
    } from '../../api/version'

    export default {
        data() {
            return {
                num: 0,
                row: {},
                userInfo: {},
                rentDay: '',
                wayValue: '',
                backCount: 0,
                withholdCount: 0,
                sendForm: {
                    shipper: ''
                },
                form: {},
                dialogFormVisible: false,
                waysArr: [{
                    value: 'self',
                    name: '自提'
                }, {
                    value: 'express',
                    name: '快递'
                }],
                expressArr: [{
                    value: 'SF',
                    name: '顺丰'
                }],
                options: [],
                value5: [],
                items: [],
                cur: '',
                productVal: [],
                allProduct: [],
                isFinish: false
            }
        },
        created() {


            getOrderId(sessionStorage.userId, this.$route.params.id).then(res => {
                console.log(res, 'd')
                this.row = res.data
                this.items = JSON.parse(JSON.stringify(this.row.orderItems));
                // this.items.forEach(item => {
                //     item.productIds = []
                // })

                getUsersDetail(sessionStorage.userId, res.data.userId).then(res => {
                    this.userInfo = res.data
                })

                let day = ''

                if (res.data && res.data.dispalyExtra && res.data.dispalyExtra.tenancy.length) {
                    console.log(res.data.dispalyExtra.tenancy, 'f')
                    day = parseInt((new Date(res.data.dispalyExtra.tenancy[0].end) - new Date(res.data.dispalyExtra.tenancy[0].begin)) / (1000 * 60 * 60 * 24))
                    this.rentDay = day === 0 ? '1' : day + 1
                }

                if (res.data.delivery && res.data.delivery.sendShipper) {
                    let filter = {
                        'where': {
                            'expressNum': res.data.delivery.sendExpressNum,
                            'shipper': res.data.delivery.sendShipper
                        }
                    }

                    console.log(filter)
                    getExpress(sessionStorage.userId, JSON.stringify(filter)).then(res => {
                        console.log(res.data)
                        this.expressData = res.data[0]

                    })
                }
            })
        },
        methods: {
            fromatDate(str) {
                function double(val) {
                    if (val > 9) {
                        return val;
                    }
                    return '0' + val;
                }

                const d = new Date(str);
                const year = d.getFullYear();
                const month = d.getMonth() + 1;
                const date = d.getDate();

                return double(year) + '-' + double(month) + '-' + double(date);
            },
            handleBack() {
                history.go(-1)
            },
            back() {
                    // if(this.items.length != this.num) {
                    //
                    //     this.$message.error('请先入库完商品')
                    //     return false;
                    // }
                if(!this.backCount && !this.row.isAlipayMini) {
                    this.$message({
                        type: 'info',
                        message: '请填写押金退还金额'
                    });
                }

                this.$confirm('此操作将确认入库, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.isFinish = true;
                    finishOrder(sessionStorage.userId, this.$route.params.id, {depositRefundCount: this.backCount*1, withholdCount: this.withholdCount * 1}).then( res => {
                        if(res.data) {
                            this.$message({
                                message: '已确认',
                                type: 'success'
                            });
                            history.go(-1)
                        }
                    }, err => {
                        this.$message.error(err.response.data.error.message)
                    })
                })
            },
            handleChoose(index, row) {
                this.dialogFormVisible = true
                this.cur = index
                getProducts(sessionStorage.userId, JSON.stringify({
                    'where': {
                        'productDetailId': row.productDetailId,
                        'isOnline': true
                    }
                })).then(res => {
                    if (res.data) {
                        this.productVal = []
                        let row = this.row.orderItems[index]

                        if (row.productIds) {
                            row.productIds.forEach(id => {
                                res.data.forEach(item => {
                                    var oflag = true
                                    if (item.productId === id) {
                                        this.productVal.push(item)
                                        for (var i = 0; i < this.allProduct.length; i++) {
                                            if (this.allProduct[i].productId === id) {
                                                oflag = false
                                            }
                                        }

                                        if (oflag) {
                                            this.allProduct.push(item)
                                        }
                                    }
                                })
                            })

                        }
                    }
                })
                console.log(row)
            },
            sureNow() {
                console.log(this.productVal)
                this.productVal.forEach( item => {
                    console.log(item)
                    this.num++
                    patchProductsIds(sessionStorage.userId, item.productId, {'otherProperty': item.otherProperty}).then( res => {

                    })
                })

                this.dialogFormVisible = false
            },
            onSubmit() {
                if (!this.sendForm.expressNumber) {
                    this.$message.error('请填写快递单号')
                } else if (this.wayValue != 'self' && !this.sendForm.shipper) {
                    this.$message.error('请选择快递公司')
                } else {

                    this.sendForm.products = []
                    this.items.forEach(item => {
                        this.sendForm.products.push({
                            orderItemId: item.productDetailId,
                            productIds: item.productIds
                        })
                    })
                    console.log(this.wayValue)
                    if (this.wayValue === 'self') {
                        this.sendForm.shipper = 'SELF'
                    }

                    this.$confirm('此操作将确认发货, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {

                        sendExpress(sessionStorage.userId, this.$route.params.id, this.sendForm).then(res => {
                            console.log(res.data)
                            if (res.data) {
                                this.$message({
                                    message: '已发货',
                                    type: 'success'
                                });
                                this.$router.push('/orderExpress')
                            }
                        })

                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消发货'
                        });
                    });


                }


            },
        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }

    .top-header {
        overflow: hidden;
    }

    .top-header p.text-left {
        float: left;
    }

    .top-header .el-select {
        float: right;
    }

    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }

    .border {
        border-bottom: 1px solid #000;
        padding-bottom: 10px;
        margin-bottom: 20px;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .line {
        display: inline-block;
        height: 1px;
        width: 20px;
        border-top: 1px solid #000;
        vertical-align: middle;
        margin: 0 10px;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// BackDevice.vue?96ce5f28